import { __assign } from "tslib";
import { createClient } from '@wix/sdk/client';
import * as cart from '@wix/auto_sdk_ecom_cart';
import { getSDKAuthAndHost } from '../getSDKAuthAndHost';
var CartService = /** @class */ (function () {
    function CartService(siteStore) {
        this.cartApi = createClient(__assign(__assign({}, getSDKAuthAndHost(siteStore)), { modules: {
                cart: {
                    getCart: cart.getCart,
                },
            } })).cart;
    }
    CartService.prototype.getCart = function (cartId) {
        return this.cartApi.getCart(cartId);
    };
    return CartService;
}());
export { CartService };
//# sourceMappingURL=CartService.js.map